import { DealersResponse } from '../../../types/Dealers'
import { RootState } from '../types'

export const FETCH_GET_DEALERS_PENDING = 'dealers//FETCH_GET_DEALERS_PENDING'
export const FETCH_GET_DEALERS_DONE = 'dealers//FETCH_GET_DEALERS_DONE'
export const FETCH_GET_DEALERS_ERROR = 'dealers//FETCH_GET_DEALERS_ERROR'

interface DealersState {
  pending: boolean
  data: DealersResponse
  error: boolean | null
}

interface PendingAction {
  type: typeof FETCH_GET_DEALERS_PENDING
}

interface DoneAction {
  type: typeof FETCH_GET_DEALERS_DONE
  payload: {
    data: DealersResponse
  }
}

interface ErrorAction {
  type: typeof FETCH_GET_DEALERS_ERROR
  payload: {
    err: unknown
  }
}

type DealersActions = PendingAction | DoneAction | ErrorAction

export function pending(): PendingAction {
  return {
    type: FETCH_GET_DEALERS_PENDING,
  }
}

export function done(data: DealersResponse): DoneAction {
  return {
    type: FETCH_GET_DEALERS_DONE,
    payload: {
      data,
    },
  }
}

export function error(err: unknown): ErrorAction {
  return {
    type: FETCH_GET_DEALERS_ERROR,
    payload: {
      err,
    },
  }
}

export function getDealersData(store: RootState): DealersState['data'] {
  return (store.dealers.data || {}) as DealersResponse
}

const initialState: DealersState = {
  pending: false,
  data: {} as DealersResponse,
  error: null,
}

// eslint-disable-next-line func-names
export default function dealersReducer(
  state: DealersState | undefined,
  action: DealersActions
): DealersState {
  const currentState = state || initialState
  switch (action.type) {
    case FETCH_GET_DEALERS_PENDING:
      return {
        ...currentState,
        data: {} as DealersResponse,
        pending: true,
        error: null,
      }

    case FETCH_GET_DEALERS_DONE:
      return {
        ...currentState,
        data: action.payload.data,
        pending: false,
        error: null,
      }
    case FETCH_GET_DEALERS_ERROR:
      return {
        ...currentState,
        data: {} as DealersResponse,
        pending: false,
        error: true,
      }

    default:
      return currentState
  }
}
